import React, { useEffect, useState } from "react";
import useStyles from "../../../components/common/model/styles";
import Popup from "../../../components/common/model/Popup";
import closeIcon from "../../../assets/closeModel.png";
import checkedIcon from "../../../assets/check-mark.png";
import deleteIcon from "../../../assets/trash.png";
import {
  DialogContent,
  DialogContentText,
  Grid,
  Typography,
} from "@mui/material";
import Validation from "../../../utils/Validation";
import { useDispatch } from "react-redux";
import { accountPasswordFields } from "./accountAllFields";
import FormField from "../../../components/common/FormField";
import { getChangePasswordAction, setChangePasswordAction } from "../../../store/reducers/userSlice";
import { setNotificationAction } from "../../../store/reducers/mmymSlice";
import Notification from "../../../components/common/notification/Notification";
import { Cancel, CheckCircle } from "@mui/icons-material";
import { useSelector } from "react-redux";
import ResetFormAlert from "./ResetFormAlert";

interface PasswordDetail {
  previousPassword: string | null;
  proposedPassword: string | null;
  confirmPassword: string | null;
  [key: string]: string | null;
}

interface ManagePasswordProps {
  open: boolean; // Define the 'open' prop
  onHide: () => void; // Define the 'onHide' prop
  title: string; // Define the 'title' prop
  selectClient: any; // Adjust type as per your requirement
}

export default function ManagePassword(props: ManagePasswordProps) {
  const dispatch = useDispatch();
  const [isActionCalled, setIsActionCalled] = useState(false);
  const [passwordDetail, setPasswordDetail] = useState<PasswordDetail>({
    previousPassword: null,
    proposedPassword: null,
    confirmPassword: null,
  });

  const [validateAction, setValidateAction] = useState({call: false, id: ""})

  const { isPasswordChangedSuccess } = useSelector((state: any) => state.user);

  const [error, checkValidator, resetValidator, resetAllValidator, isError] =
    Validation(passwordDetail);

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    checkValidator();
    setIsActionCalled(true);
  };

  useEffect(() => {
    if (isActionCalled) {
      if (!isError() && error !== null && isActionCalled) {
        const {confirmPassword, ...payload} = passwordDetail;
        dispatch(getChangePasswordAction(payload));
      }
      setIsActionCalled(false);
    }
  }, [isActionCalled]);

  useEffect(()=>{
    if(isPasswordChangedSuccess){
      console.log("api success")
      hideHandler();
      dispatch(setChangePasswordAction(false));
    }
  },[isPasswordChangedSuccess])

  const onChangeAction = (e: any) => {
    const id = e?.target?.id;
    const value = e?.target?.value;
    setPasswordDetail({
      ...passwordDetail,
      [id]: value,
    });
    setValidateAction({call: true, id: e.target.id});
  };

  useEffect(()=>{
    if(validateAction?.call){
      checkValidator(validateAction?.id);
      setValidateAction({call: false, id: ""});
    }
  }, [validateAction])

  const onBlurAction = (e: any) => {
    checkValidator(e.target.id);
  };

  const { selectClient, onHide, open, title } = props;

  const [fullWidth, setFullWidth] = useState(true);

  const classes = useStyles();

  const hideHandler = () => {
    props.onHide();
    dispatch(setNotificationAction({ message: [], severity: "error" }));
    setPasswordDetail({
      previousPassword: '',
      proposedPassword: '',
      confirmPassword: '',
  })
  resetAllValidator();
  };

  const clearHandler = () => {
    dispatch(setNotificationAction({ message: [], severity: "error" }));
    setPasswordDetail({
        previousPassword: '',
        proposedPassword: '',
        confirmPassword: '',
    })
    resetAllValidator();
  };

  const [alerModeShow, setAlertModelShow] = useState(false);
  const [isClickReset, setIsClickReset] = useState(false);

  const openClearPopup = () => {
    setAlertModelShow(true);
  };

  useEffect(() => {
    if (isClickReset) {
      clearHandler();
      setAlertModelShow(false);
      setIsClickReset(false);
    }
  }, [isClickReset]);

  return (
    <>
      <Popup
        open={open}
        title={title}
        onHide={hideHandler}
        fullWidth={fullWidth}
        maxWidth={"sm"}
        aria-describedby="alert-dialog-slide-description"
        popupBg="#fff"
        header={
          <>
            <img
              onClick={(e: any) => handleSubmit(e)}
              src={checkedIcon}
              className={classes.checkicons}
              alt="save"
            />
            <img
              onClick={openClearPopup}
              src={deleteIcon}
              className={classes.deleteicons}
              alt="delete"
            />
            <img
              onClick={hideHandler}
              src={closeIcon}
              className={classes.closeicons}
              alt="close"
            />
          </>
        }
      >
        <DialogContent sx={{padding:'10px'}}>
          <DialogContentText sx={{padding:'10px 16px', background:'#E5F4F1',borderRadius:'5px',border:'1px solid #CFCFCF'}}>
            <>
              <Notification />
              {accountPasswordFields.map((field, i) => {
                return (
                  !selectClient && (
                    <Grid
                      container
                      spacing={2}
                      key={i}
                      style={{ marginLeft: "0px", width: "100%" }}
                    >
                      <FormField
                        {...{
                          ...field,
                          variant: "outlined",
                          onChange: onChangeAction,
                          onBlur: onBlurAction,
                          InputProps: {
                            ...field?.autocomplete && {autocomplete: field?.autocomplete},
                            ...(field?.id === "email" && { disabled: true }),
                            sx:
                              field?.type === "text" || field?.type === "number" || field?.type === "password"
                                ? { height: "36px" }
                                : { padding: "10px 4px", height: "40px" },
                          },
                          error: error && error[field?.id],
                          ...field?.id === "confirmPassword" && {helperText: error && error[field?.id]},
                          value: passwordDetail
                            ? passwordDetail[field?.id]
                            : "",
                        }}
                      />
                      {field?.id === "proposedPassword" && (
                        <Typography
                          className={`passwordRules ${
                            error &&
                            passwordDetail[field?.id] &&
                            "valid"
                          }`}
                        >
                          <h4>Your password must have:</h4>
                          <table>
                            <tr
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <td>
                                <p
                                  style={{
                                    marginBottom: "0px",
                                    marginTop: "0px",
                                    textAlign: "center",
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                  className={
                                    passwordDetail[field?.id]
                                      ? error &&
                                        error?.proposedPassword?.lowercase &&
                                        error[field?.id]?.lowercase
                                        ? "invalid"
                                        : "valid"
                                      : ""
                                  }
                                >
                                  {!passwordDetail?.proposedPassword ? (
                                    <Cancel
                                      style={{ color: "red", width: "16px" }}
                                    />
                                  ) : error?.proposedPassword?.lowercase ? (
                                    <Cancel
                                      style={{ color: "red", width: "16px" }}
                                    />
                                  ) : (
                                    <CheckCircle
                                      style={{ color: "green", width: "16px" }}
                                    />
                                  )}{" "}
                                  <span
                                    style={{
                                      marginTop: "0px",
                                      marginLeft: "4px",
                                      color: "#999999",
                                    }}
                                  >
                                    At least one lowercase letter
                                  </span>
                                </p>
                              </td>
                              <td style={{ textAlign: "center" }}>
                                <p
                                  style={{
                                    margin: "0px",
                                    marginLeft: "12px",
                                    marginTop: "0px",
                                    textAlign: "center",
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                  className={
                                    passwordDetail[field?.id]
                                      ? error &&
                                        error?.proposedPassword?.uppercase &&
                                        error[field?.id]?.uppercase
                                        ? "invalid"
                                        : ""
                                      : ""
                                  }
                                >
                                  {!passwordDetail?.proposedPassword ? (
                                    <Cancel
                                      style={{ color: "red", width: "16px" }}
                                    />
                                  ) : error?.proposedPassword?.uppercase ? (
                                    <Cancel
                                      style={{ color: "red", width: "16px" }}
                                    />
                                  ) : (
                                    <CheckCircle
                                      style={{ color: "green", width: "16px" }}
                                    />
                                  )}{" "}
                                  <span
                                    style={{
                                      marginTop: "0px",
                                      marginLeft: "4px",
                                      color: "#999999",
                                    }}
                                  >
                                    At least one UPPERCASE letter
                                  </span>
                                </p>
                              </td>
                            </tr>
                            <tr
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <td>
                                <p
                                  style={{
                                    margin: "0px",
                                    marginTop: "0px",
                                    textAlign: "center",
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                  className={
                                    passwordDetail[field?.id]
                                      ? error &&
                                        error?.proposedPassword?.number &&
                                        error[field?.id]?.number
                                        ? "invalid"
                                        : ""
                                      : ""
                                  }
                                >
                                  {!passwordDetail?.proposedPassword ? (
                                    <Cancel
                                      style={{ color: "red", width: "16px" }}
                                    />
                                  ) : error?.proposedPassword?.number ? (
                                    <Cancel
                                      style={{ color: "red", width: "16px" }}
                                    />
                                  ) : (
                                    <CheckCircle
                                      style={{ color: "green", width: "16px" }}
                                    />
                                  )}{" "}
                                  <span
                                    style={{
                                      marginTop: "0px",
                                      marginLeft: "4px",
                                      color: "#999999",
                                    }}
                                  >
                                    At least one number
                                  </span>
                                </p>
                              </td>
                              <td>
                                <p
                                  style={{
                                    margin: "0px",
                                    marginLeft: "70px",
                                    marginTop: "0px",
                                    textAlign: "center",
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                  className={
                                    passwordDetail[field?.id]
                                      ? error &&
                                        error?.proposedPassword?.special &&
                                        error[field?.id]?.special
                                        ? "invalid"
                                        : ""
                                      : ""
                                  }
                                >
                                  {!passwordDetail?.proposedPassword ? (
                                    <Cancel
                                      style={{ color: "red", width: "16px" }}
                                    />
                                  ) : error?.proposedPassword?.special ? (
                                    <Cancel
                                      style={{ color: "red", width: "16px" }}
                                    />
                                  ) : (
                                    <CheckCircle
                                      style={{ color: "green", width: "16px" }}
                                    />
                                  )}{" "}
                                  <span
                                    style={{
                                      marginTop: "0px",
                                      marginLeft: "4px",
                                      color: "#999999",
                                    }}
                                  >
                                    At least one special character
                                  </span>
                                </p>
                              </td>
                            </tr>
                            <p
                              style={{
                                marginTop: "0px",
                                textAlign: "center",
                                display: "flex",
                                alignItems: "center",
                                marginBottom:'10px'
                              }}
                              className={
                                passwordDetail[field?.id]
                                  ? error &&
                                    error?.proposedPassword?.length &&
                                    error[field?.id]?.length
                                    ? "invalid"
                                    : ""
                                  : ""
                              }
                            >
                              {!passwordDetail?.proposedPassword ? (
                                <Cancel
                                  style={{ color: "red", width: "16px" }}
                                />
                              ) : error?.proposedPassword?.length ? (
                                <Cancel
                                  style={{ color: "red", width: "16px" }}
                                />
                              ) : (
                                <CheckCircle
                                  style={{ color: "green", width: "16px" }}
                                />
                              )}{" "}
                              <span
                                style={{
                                  marginTop: "0px",
                                  marginLeft: "4px",
                                  color: "#999999",
                                }}
                              >
                                Minimum 8 characters
                              </span>
                            </p>
                          </table>
                        </Typography>
                      )}
                    </Grid>
                  )
                );
              })}
            </>
          </DialogContentText>
        </DialogContent>
      </Popup>
      {alerModeShow && (
        <ResetFormAlert
          open={alerModeShow}
          title=""
          alertModalShow={alerModeShow}
          setAlertModelShow={setAlertModelShow}
          setIsClickReset={setIsClickReset}
        />
      )}
    </>
  );
}
